<template>
  <b-card class="jlr-brand-card cx-card" 
          :class="{'jaguar-style': brand == 'Jaguar', 
                  'landrover-style': brand == 'Land Rover'}">
 
    <img  class="mx-auto img-fluid jlr-brand-card-logo" :src="`/static/img/${logoName}`" />

    <b-card-text class="msm-title" style="letter-spacing: -0.025em; font-size: 1.2rem;">
      {{ actualTitle }}
    </b-card-text>

    <b-card-text v-if="!loadingData">
      <slot />
    </b-card-text>

  </b-card>
</template>

<script>
import EventBus from "@/services/EventBus";

export default {
  components: {
  },

  props: {
    brand:  { type: String, default: 'Jaguar' },
    theme:  { type: String, default: () => 'light' },
    title:  { type: String, default: '' },
    name:   { type: String, default: undefined },
  },

  data() {
    return {
      loadingData: false,
      showPopup: false,
      titleAppendix: null
    };
  },

  mounted() {
    if (this.name === 'NPS') {
      this.titleAppendix = '55';
      EventBus.$on('nps-margin-header', this.handleNpsMarginHeader);
    }
  },

  beforeDestroy() {
    if (this.name === 'NPS') {
      EventBus.$off('nps-margin-header', this.handleNpsMarginHeader);
    }
  },

  methods: {
    handleNpsMarginHeader(data) {
      this.titleAppendix = data;
    }
  },

  computed: {
    actualTitle() {
      let title = this.$t(this.title);
      if (this.name === 'NPS' && this.titleAppendix && this.titleAppendix.length > 0) {
        title = title + ' +' + this.titleAppendix;
      }
      return title;
    },
    logoName() {
      let themeFlavour = this.theme === 'light' ? '' : '-dark';
      return this.brand == "Jaguar" 
        ? `jaguar-logo-23${themeFlavour}.png`
        : `landrover-logo-23${themeFlavour}.png`;
    }
  }
};
</script>
